import React from 'react';

const NotificationBell = ({ width = '23', height = '22', ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 23 22"
    fill="none"
    {...props}
  >
    <path
      d="M9.37891 19.4878H13.2373"
      stroke="#EF4444"
      strokeWidth="2.14354"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M3.5918 15.6289H19.0253L17.1424 6.84152C16.8575 5.50561 16.1227 4.30794 15.0609 3.44868C13.999 2.58941 12.6745 2.12061 11.3085 2.12061C9.94257 2.12061 8.618 2.58941 7.55617 3.44868C6.49433 4.30794 5.75957 5.50561 5.47468 6.84152L3.5918 15.6289Z"
      stroke="#EF4444"
      strokeWidth="2.14354"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default NotificationBell;
